/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddressTag {
    HEAD_OFFICE = 'head_office',
    REGISTERED_ADDRESS = 'registered_address',
    PRIMARY_ADDRESS = 'primary_address',
}
